import { ActionTypes } from "../../constants/ActionTypes";
import { ThemeSetting } from "../../constants/ThemeSetting";

const { NAV_STYLE } = ThemeSetting;

export function toggleCollapsedSideNav(navCollapsed: boolean) {
  return { type: ActionTypes.TOGGLE_COLLAPSED_NAV, navCollapsed };
}

export function onNavStyleChange(navStyle: string) {
  return (dispatch: Function) => {
    dispatch({ type: NAV_STYLE, navStyle });
  };
}

